/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-19 11:13:55                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-24 15:46:25                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Users: Users list view
*/

/* Imports */
import { t } from "../../i18n";
import { TruckIcon, UserCircleIcon,  } from "@heroicons/react/24/solid";
import { DocumentChartBarIcon,CalendarIcon, ClockIcon } from "@heroicons/react/24/outline";
import { Typography, IconButton, Tooltip } from "@material-tailwind/react";
import { useDrawerLayoutDispatch } from "../../components/drawer-layout/DrawerLayout";
import { ExportDrawer } from "../../components/users/ExportDrawer";
import { UnavailabilitiesDrawer } from "../../components/users/UnavailabilitiesDrawer";
import { OvertimeExportDrawer } from "../../components/users/OvertimeExportDrawer";
/***/

/* Components */
import { TabsNav } from "../../components/tabs/TabsNav";
import UsersTab from "./tabs/UsersTab";
import TechniciansTab from "./tabs/TechniciansTab";
import { Breadcrumb } from "../../components/breadcrumb/Breadcrumb";
/***/

import "./Users.scss";
/**
* Users: Users list view
* display all users 
*/
export function Users({
  isAdminComponent,
}: {
  isAdminComponent?: boolean
}) {
  const dispatch = useDrawerLayoutDispatch();

  const tabs = [{
    label: t("common:users"),
    icon: UserCircleIcon,
    value: "users",
    Component: <UsersTab isAdminComponent={isAdminComponent}  />
  }, {
    label: t("menu:technicians"),
    icon: TruckIcon,
    value: "technicians",
    Component: <TechniciansTab isAdminComponent={isAdminComponent} />
  }];

  const handleOpenExportDrawer = () => {
    dispatch({
      type: "open",
      title: t("common:exportPerformances:title"),
      content: <ExportDrawer />
    });
  };

  const handleOpenUnavailabilitiesDrawer = () => {
    dispatch({
      type: "open",
      title: t("common:techniciansUnavailabilities"),
      content: <UnavailabilitiesDrawer />
    });
  };

  const handleOpenOvertimeExportDrawer = () => {
    dispatch({
      type: "open",
      title: t("common:exportOvertimeStats"),
      content: <OvertimeExportDrawer />
    });
  };

  const actions = [
    { 
      icon: <CalendarIcon className="icon text-blue-500" />, 
      type: "export-unavailabilities",
      tooltip: t("technician:exportUnavailability"),
      onClick: handleOpenUnavailabilitiesDrawer
    },
    { 
      icon: <DocumentChartBarIcon className="icon text-red-500" />, 
      type: "export-performances",
      tooltip: t("common:exportPerformances:title"),
      onClick: handleOpenExportDrawer
    },
    { 
      icon: <ClockIcon className="icon text-orange-500" />, 
      type: "export-overtime",
      tooltip: t("common:exportOvertimeStats"),
      onClick: handleOpenOvertimeExportDrawer
    }
  ];
  
  return (
    <div className="views-padded">
      <div className="my-4">
        {(isAdminComponent === undefined || isAdminComponent === false) &&
          <Breadcrumb path={[{name: t("common:users"), path: "/users"}]} />
        } 

        <div className="flex justify-between items-center actions">
          <Typography variant={(isAdminComponent === undefined || isAdminComponent === false) ? "h2" : "h4"}>
            {t("common:users")}
          </Typography>
          <div className="icon-buttons flex gap-2">
            {actions.map((action, index) => (
              <Tooltip key={index} content={action.tooltip}>
                <IconButton 
                  className="icon-button bg-white"
                  onClick={action.onClick}
                >
                  {action.icon}
                </IconButton>
              </Tooltip>
            ))}
          </div>
        </div>
      </div>

      <TabsNav<any> defaultTab="users" tabs={tabs} data={{}}/>
    </div>
  );
}
/***/
